module.exports = __webpack_public_path__ + "fonts/iconfont.0ef7990.woff2";